import style from './ErrorTable.module.scss'

export const ErrorTable = ({ importData }: { importData: importData[] }) => {
    return (
        <table className={style.errorTable}>
            <thead>
                <tr>
                    <th>Row</th>
                    <th>Property</th>
                    <th>Error Description</th>
                </tr>
            </thead>
            <tbody>
                {importData.map((rowData: importData, index: number) => {
                    if (rowData.ErrorCount > 0) {
                        return (
                            <tr key={index}>
                                <td>{rowData.Row.Value}</td>
                                {rowData.LOBCode && rowData.LOBCode.Error && (
                                    <>
                                        <td>LOBCode</td>
                                        <td>{String(rowData.LOBCode.Error)}</td>
                                    </>
                                )}
                                {rowData.VendorID && rowData.VendorID.Error && (
                                    <>
                                        <td>VendorId</td>
                                        <td>{String(rowData.VendorID.Error)}</td>
                                    </>
                                )}
                            </tr>
                        )
                    }
                    return null
                })}
            </tbody>
        </table>
    )
}